import {PAGE_URL, PERMISSION_KEY} from "../services/constant";
const billingMenuRegistry = {
    core_billing: {
        label: "Billing",
        link: PAGE_URL.BILLING_PAGE,
        key: PAGE_URL.BILLING_PAGE,
        resourceKey: PERMISSION_KEY
    }
}

export default billingMenuRegistry;
